module.exports = __webpack_public_path__ + "img/96f9bf9aecc93dbd6078ca3a16de5629.ef981715.png";